import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { AES, enc } from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  rutaApi: string = environment.rutaApi;
  rutaApiMovil: string = environment.rutaApiMovil;
  _baseUrl: string = environment._baseUrl
  secretCookieWord: string = 'ENCRIPTACOOKIES'
  mensajesNoLeidos$ = new EventEmitter<any>();
  alarma$ = new EventEmitter<any>();
  evento$ = new EventEmitter<any>();

  constructor(
    private http: HttpClient
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  httpOptionsUpload = {
    headers: new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      'Accept': '*/*'
    })
  };

  rutaBase = 'https://clientes.controlguard.cl/'
  encriptado: boolean = false

  async getDashboardStatsService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'dashboard/stats').toPromise();
      return response;
    } catch (error) {
      console.error('Error en getDashboardStatsService:', error);
    }
  }

  setLocalstorage(nombre: string, dato: string) {
    let enc
    if (this.encriptado) {
      enc = AES.encrypt(dato, this.secretCookieWord);
      localStorage.setItem(nombre, enc)
    }
    else
      localStorage.setItem(nombre, dato)
  }

  getLocalstorage(data: string) {
    let aux = localStorage.getItem(data)
    if (aux == null) return null
    let decrypted
    if (this.encriptado) {
      decrypted = AES.decrypt(aux, this.secretCookieWord);
      return decrypted.toString(enc.Utf8)
    }
    return aux
  }

  // Es para cuando la está cambiando desde el interior de la página
  updatePasswordService(email: string, password: string, oldPassword: string) {
    let datos = { Email: email, Password: password, oldPassword: oldPassword }
    return <Observable<any>>this.http.put(this.rutaApi + 'updatepassword', datos, this.httpOptions).pipe();
  }

  // Es para cuando está recuperando la clave
  updatePasswordWithoutOldPasswordService(email: string, password: string) {
    let datos = { Email: email, Password: password }
    return <Observable<any>>this.http.put(this.rutaApi + 'updatepassword', datos, this.httpOptions).pipe();
  }

  getPasswordByEmailService(email: string) {
    return <Observable<any>>this.http.get(this.rutaApi + 'recuperaClave/' + email).pipe();
  }

  recuperapasswordService(email: string) {
    return <Observable<any>>this.http.get(this.rutaApi + 'recuperaClave/' + email).pipe();
  }

  loginService(email: string, password: string) {
    let datos = { Email: email, Password: password }
    return <Observable<any>>this.http.post(this.rutaApi + 'login', datos, this.httpOptions).pipe();
  }

  async countGuardiasByIdEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'countguardiasByIdEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async countUsuariosService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'countusuarios').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }


  getGuardiaEnTurnoService(idinstalacion: number) {
    console.log('getGuardiaEnTurnoService')
    return this.http.get<any[]>(this.rutaApi + 'getGuardiaEnTurno/' + idinstalacion)
  }


  updateClienteService(cliente: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'updatecliente', cliente, this.httpOptions).pipe();
  }

  updateGuardiaService(guardia: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'updateguardia', guardia, this.httpOptions).pipe();
  }

  updateInstalacionService(instalacion: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'updateinstalacion', instalacion, this.httpOptions).pipe();
  }

  liberarCodigoService(idinstalacion: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'liberarcodigo', { _id: idinstalacion }, this.httpOptions).pipe();
  }

  rondaInmediataService(idinstalacion: any) {
    return <Observable<any>>this.http.get(this.rutaApiMovil + 'rondainmediata/' + idinstalacion).pipe();
  }

  newInstalacionService(instalacion: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newinstalacion', instalacion, this.httpOptions).pipe();
  }

  newClienteService(cliente: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newcliente', cliente, this.httpOptions).pipe();
  }

  newGuardiaService(guardia: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newguardia', guardia, this.httpOptions).pipe();
  }

  clientesbyEmpresaService_old(idempresa: string) {
    console.log('clientesbyEmpresaService')
    return this.http.get<any[]>(this.rutaApi + 'getEmpresasByIdCliente/' + idempresa)
  }

  async getAccesosByClienteService(idcliente: string, desde, hasta): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getAccesosByCliente/' + idcliente + '/' + desde + '/' + hasta).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getAccesosMezcladosByClienteService(idcliente: string, desde, hasta): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getAccesosMezcladosByCliente/' + idcliente + '/' + desde + '/' + hasta).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getReportesRondaByClienteService(idcliente: string, desde, hasta): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getReporteRondaByCliente/' + idcliente + '/' + desde + '/' + hasta).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getWaypointsRondaBService(idinstalacion: string, desde, hasta): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getWaypointsRonda/' + idinstalacion + '/' + desde + '/' + hasta).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getUsuariosAccesosByClienteService(idcliente: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getUsuariosAccesosByCliente/' + idcliente).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getUsuariosByEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getUsuariosByEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getAllUsuariosService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getAllUsuarios').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }
  // DOCUMENTOS

  descargaComprobante(nombreArchivo) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(this._baseUrl + nombreArchivo, { responseType: 'blob' });
  }

  updateUploadDatosClienteService(file: any, data) {
    const formData: FormData = new FormData();
    if (file != undefined)
      formData.append('logo', file, file.name);

    formData.append('data', JSON.stringify(data))
    return this.http.put<any>(this.rutaApi + 'updateuploadcliente', formData, this.httpOptionsUpload).pipe();
  }

  uploadDatosClienteService(file: any, data) {
    const formData: FormData = new FormData();
    if (file != undefined)
      formData.append('logo', file, file.name);

    formData.append('data', JSON.stringify(data))
    return this.http.post<any>(this.rutaApi + 'uploadcliente', formData, this.httpOptionsUpload).pipe();
  }

  uploadFilesService(file: any, data) {
    const formData: FormData = new FormData();
    if (file != undefined)
      formData.append('Documento', file, file.name);

    formData.append('data', JSON.stringify(data))
    return this.http.post<any>(this.rutaApi + 'uploaddocumento', formData, this.httpOptionsUpload).pipe();
  }

  updateDocumentoService(documento: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'updatedocumento', documento, this.httpOptions).pipe();
  }

  deleteDocumentoService(iddocumento: number) {
    return this.http.delete<any[]>(this.rutaApi + 'deletedocumento/' + iddocumento)
  }

  newDocumentoService(documento: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newdocumento', documento, this.httpOptions).pipe();
  }

  async getdocumentosbyClienteService(idcliente: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getDocumentosByCliente/' + idcliente).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getclientesbyEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getClientesByEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getAllClientesService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'allclientes').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getEmpresaService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getempresas').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getConfiguracionesPaisesService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getconfiguracionespaises').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getCampaignsService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getcampaigns').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getMarketingByCampaignsService(idcampaign: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getmarketingbycampaing/' + idcampaign).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  updateEmpresaService(empresa: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'updateempresa', empresa, this.httpOptions).pipe();
  }

  newEmpresaService(empresa: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newempresa', empresa, this.httpOptions).pipe();
  }

  /**
   * Crea una nueva empresa con o sin logo en una sola petición
   * @param formData FormData con todos los datos de la empresa y opcionalmente el archivo de logo
   * @returns Observable con la respuesta del servidor
   */
  newEmpresaConLogoService(formData: FormData): Observable<any> {
    // El endpoint podría ser el mismo que newEmpresaService pero debe manejar multipart/form-data
    return this.http.post(this.rutaApi + 'newempresaconlogo', formData)
      .pipe(
        retry(1),
        // catchError(this.handleError)
      );
  }

  /**
 * Crea una nueva empresa con o sin logo en una sola petición
 * @param formData FormData con todos los datos de la empresa y opcionalmente el archivo de logo
 * @returns Observable con la respuesta del servidor
 */
  updateEmpresaConLogoService(formData: FormData): Observable<any> {
    // El endpoint podría ser el mismo que newEmpresaService pero debe manejar multipart/form-data
    return this.http.put(this.rutaApi + 'updateempresaconlogo', formData)
      .pipe(
        retry(1),
        // catchError(this.handleError)
      );
  }

  deleteEmpresaService(idempresa: any) {
    return this.http.delete(this.rutaApi + 'deleteempresa/' + idempresa)
  }

  async getguardiasbyEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'guardiasByIdEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }


  async countSupervisoresbyEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'countSupervisoresbyIdEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async countAllSupervisoresService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'countAllSupervisores').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getsupervisoresbyEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'supervisoresbyIdEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getAllSupervisoresService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getAllSupervisores').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }


  newSupervisorService(supervisor: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newsupervisor', supervisor, this.httpOptions).pipe();
  }

  updateSupervisorService(supervisor: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'updatesupervisor', supervisor, this.httpOptions).pipe();
  }

  deleteSupervisorService(isdupervisor: number, eliminacionTotal: boolean = false) {
    return this.http.delete<any[]>(this.rutaApi + 'deletesupervisor/' + isdupervisor + '/' + eliminacionTotal)
  }

  usuarioscedulasByIdClienteService(idcliente: number) {
    console.log('usuarioscedulasByIdClienteService')
    return this.http.get<any[]>(this.rutaApi + 'usuarioscedulasByIdCliente/' + idcliente)
  }

  rondasByIdInstalacionService(idinstalacion: number) {
    console.log('rondasByIdInstalacionService')
    return this.http.get<any[]>(this.rutaApi + 'rondasByIdInstalacion/' + idinstalacion)
  }

  async rondasByEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getrondasbyempresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  newRondaService(rondas: any) {
    return this.http.post(this.rutaApi + 'newronda', rondas, this.httpOptions)
  }

  updateRondaService(ronda: any) {
    return this.http.put(this.rutaApi + 'updateronda/', ronda, this.httpOptions)
  }

  deleteRondaService(id: string) {
    return this.http.delete(this.rutaApi + 'deleteronda/' + id)
  }

  async instalacionesByIdClienteService(idcliente: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'instalacionesByCliente/' + idcliente).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async avanceInstalacionesService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'reporteAvanceInstalaciones').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async countInstalacionesByEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'countInstalacionesByEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getinstalacionesByEmpresaService(idempresa: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'instalacionesByEmpresa/' + idempresa).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getinstalacionesGroupByEmpresaService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'instalacionesgroupbyempresa').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getDtesByYearMonthService(year: number, month: number): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getDtesByYearMonth/' + year + '/' + month).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  newDteService(dte: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newDte', dte, this.httpOptions).pipe();
  }

  updateDteService(dte: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'updateDte', dte, this.httpOptions).pipe();
  }

  marcaPagadoService(dte: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'marcapagado', dte, this.httpOptions).pipe();
  }

  deleteDteService(idusuario: any) {
    return this.http.delete(this.rutaApi + 'deletedte/' + idusuario)
  }


  async getallinstalacionesService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'allinstalaciones').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  actualizarVersionesAppService() {
    return this.http.get(this.rutaApi + 'actualizar-versiones-app');
  }

  getEventosByIdInstalacionAndMonthService(idinstalacion: number, mes: number, year: number) {
    console.log('getEventosByIdInstalacionAndMonthService')
    return this.http.get<any[]>(this.rutaApi + 'getEventosByIdInstalacionAndMonth/' + idinstalacion + '/' + mes + '/' + year)
  }

  async getMensajesByInstalacion(idempresa: string, idcliente: string, idinstalacion: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getMensajes/' + idempresa + '/' + idcliente + '/' + idinstalacion).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getEventosByEmpresa(idempresa: string, limit: number, desde?, hasta?): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'geteventos/' + idempresa + '/' + limit + '/' + desde + '/' + hasta).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  newMensajeService(evento: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'newevento', evento, this.httpOptions).pipe();
  }

  newUsuarioCedulaWEBService(usuarios: any, idcliente: string, idinstalacion: string) {
    const obj = { usuarios, idcliente, idinstalacion }
    return this.http.post(this.rutaApi + 'newusuariocedulaWEB/', obj, this.httpOptions)
  }

  newUsuarioService(usuario: any) {
    return this.http.post(this.rutaApi + 'newusuario/', usuario, this.httpOptions)
  }

  updateUsuarioService(usuario: any) {
    return this.http.put(this.rutaApi + 'updateusuario/', usuario, this.httpOptions)
  }

  deleteUsuarioService(idusuario: any) {
    return this.http.delete(this.rutaApi + 'deleteusuario/' + idusuario)
  }

  updateUsuarioCedulaService(idusuario: any, bloqueado: boolean) {
    return this.http.put(this.rutaApi + 'updateusuariocedula/', { idusuario, bloqueado }, this.httpOptions)
  }

  // Peticiones DELETE
  deleteInstalacionService(idinstalacion: any, eliminacionTotal: boolean = false) {
    return this.http.delete(this.rutaApi + 'deleteinstalacion/' + idinstalacion + '/' + eliminacionTotal)
  }

  deleteClienteService(idcliente: any) {
    return this.http.delete(this.rutaApi + 'deletecliente/' + idcliente)
  }

  deleteGuardiaService(idguardia: any) {
    return this.http.delete(this.rutaApi + 'deleteguardia/' + idguardia)
  }

  delRelacionSupervisoresService(supervisor: any,) {
    return this.http.delete(this.rutaApi + 'deleteRelacionSupervisores/' + supervisor)
  }
  delInstalacionesService(id: number,) {
    return this.http.delete(this.rutaApi + 'instalaciones/' + id)
  }
  delSupervisoresService(id: number,) {
    return this.http.delete(this.rutaApi + 'supervisores/' + id)
  }
  delGuardiasService(idGuardia: number) {
    return this.http.delete(this.rutaApi + 'guardias/' + idGuardia)
  }
  delEmpresasService(id: number,) {
    return this.http.delete(this.rutaApi + 'empresas/' + id)
  }

  makePayment(obj: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'create', obj, this.httpOptions).pipe();
    // return <Observable<any>>this.http.post(this.rutaFacturacion + 'create_order', obj, this.httpOptions).pipe();
  }

  newPaymentService(pago: any) {
    return this.http.post<any[]>(this.rutaApi + '/create_order', pago, this.httpOptions).pipe();
  }

  getFacturasService(idempresa: string) {
    return this.http.get(this.rutaApi + 'getDtesByEmpresa/' + idempresa)
  }

  downloadPDF(nombreArchivo) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(this._baseUrl + nombreArchivo, { responseType: 'blob' });
  }

  // SYSTEM LOGS
  async getSystemLogsService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'getsystemlogs').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  async getPendingLogRequestsService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'pending-log-requests').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  // VERSIONES DE LAS APPS (colección ConfiguracionApps)
  //
  // Estas llamadas SÍ mandan el JWT: el backend audita cada cambio y sin el token
  // el registro queda como 'NO IDENTIFICADO'. Justamente acá importa saber quién
  // movió qué, porque VersionAppMinima puede dejar a toda la flota sin operar.
  private httpOptionsConToken() {
    const token = this.getLocalstorage('token')

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token ? 'Bearer ' + token : ''
      })
    }
  }

  async getConfiguracionAppsService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'configuracionapps').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  // Lo que las apps están recibiendo EN ESTE MOMENTO, ya pasado por la caché de
  // apiweb. Sirve para confirmar que lo guardado es lo que se está entregando.
  async getConfiguracionAppsVigenteService(): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'configuracionapps/vigente').toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  newConfiguracionAppService(configuracion: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'configuracionapps', configuracion, this.httpOptionsConToken()).pipe();
  }

  updateConfiguracionAppService(id: string, cambios: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'configuracionapps/' + id, cambios, this.httpOptionsConToken()).pipe();
  }

  // No hay método de borrado a propósito: estas configuraciones no se eliminan desde
  // la web, se deshabilitan. El backend sí expone el DELETE por si alguna vez hace falta.


  // ==========================================================================
  // CONECTOR MCP
  //
  // Todas mandan el JWT: revocar una credencial se audita, y sin token el
  // registro queda como 'NO IDENTIFICADO'. Acá importa más que en ningún otro
  // lado saber quién tocó qué.
  //
  // Desde el panel interno NO se EMITEN keys: las emite el cliente desde su
  // propio portal, que es donde acepta la suscripción. Por eso acá no hay ni
  // `newMcpKeyService` ni `getMcpKeysUsuariosService`. Los endpoints
  // POST /api/mcpkeys y GET /api/mcpkeys/usuarios siguen existiendo y no hay que
  // tocarlos: los consume controlguard_web.
  //
  // Tampoco hay `getMcpKeysService`: el listado de keys viene dentro de
  // /api/mcpadopcion, que además trae el alcance ya escrito y el consumo del
  // período. Pedirlo por separado eran dos respuestas que decían casi lo mismo y
  // una pantalla que las tenía que unir.
  // ==========================================================================

  // Revocar sí se hace desde acá: es la salida de emergencia, y cortar un acceso
  // nunca es lo peligroso. El motivo viaja en el cuerpo, y HttpClient solo lo
  // manda en un DELETE si se pasa dentro de la opción `body`.
  revocarMcpKeyService(id: string, motivo: string) {
    const token = this.getLocalstorage('token');
    return <Observable<any>>this.http.request('DELETE', this.rutaApi + 'mcpkeys/' + id, {
      body: { Motivo: motivo },
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token ? 'Bearer ' + token : ''
      })
    }).pipe();
  }

  // PROMOCIONES: la franja de arriba del Home en la web de clientes. Solo SUPER;
  // el backend responde 403 al resto.
  async getPromocionesService(): Promise<any> {
    try {
      return await this.http.get(this.rutaApi + 'promociones', this.httpOptionsConToken()).toPromise();
    } catch (error) {
      console.error('Error es:', error);
    }
  }

  newPromocionService(promocion: any) {
    return <Observable<any>>this.http.post(this.rutaApi + 'promociones', promocion, this.httpOptionsConToken()).pipe();
  }

  updatePromocionService(id: string, cambios: any) {
    return <Observable<any>>this.http.put(this.rutaApi + 'promociones/' + id, cambios, this.httpOptionsConToken()).pipe();
  }

  async getMcpSolicitudesService(dias: number, empresa?: string): Promise<any> {
    try {
      const filtro = '?dias=' + dias + (empresa ? '&empresa=' + empresa : '');
      let response = await this.http.get(this.rutaApi + 'mcpsolicitudes' + filtro, this.httpOptionsConToken()).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  // La adopción del conector: quiénes lo tienen encendido y cuánto suma. Es la
  // vista global —todas las empresas de una vez—, al revés de las de arriba, que
  // miran una empresa a la vez.
  //
  // Cuánto devuelve depende de la sesión: si quien consulta no es SUPER, la
  // respuesta trae SOLO su empresa. Por eso
  // se lee `alcance` y no se asume que el total es el total.
  async getMcpAdopcionService(dias: number, empresa?: string): Promise<any> {
    try {
      const filtro = '?dias=' + dias + (empresa ? '&empresa=' + empresa : '');
      let response = await this.http.get(this.rutaApi + 'mcpadopcion' + filtro, this.httpOptionsConToken()).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }


  // ==========================================================================
  // BOTÓN DE PÁNICO
  //
  // Estas llamadas mandan el JWT: el backend decide con él qué se puede ver
  // —staff de Control Guard: todas las empresas; interno: la suya; externo: sus
  // instalaciones— y audita cada cambio. Sin token responde 401.
  //
  // LA UNIDAD ES LA INSTALACIÓN, no el cliente: un condominio puede tener el
  // botón en la Puerta Norte y no en la Sur. Las rutas van por `:idinstalacion`.
  //
  // Acá NO están las llamadas de OPERACIÓN —propiedades, titulares, carga
  // masiva, usuarios, alertas—: eso lo administra cada cliente desde
  // clientes.controlguard.cl y sus endpoints los consume controlguard_web. El
  // panel interno mira lo contratado y rota los códigos.
  // ==========================================================================

  // La tabla: todas las instalaciones con el servicio, con su contrato, su cupo
  // usado y su promoción. Es la única que cruza empresas.
  async getConfiguracionesPanicoService(empresa?: string): Promise<any> {
    try {
      const filtro = empresa ? '?empresa=' + empresa : '';
      let response = await this.http.get(this.rutaApi + 'panico/configuraciones' + filtro, this.httpOptionsConToken()).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

  // Rota el nombre del topic FCM y la ruta del nodo RTDB. Es la palanca dura
  // cuando se sospecha que alguien está escuchando de más, y no es gratis: hasta
  // que cada app se resuscriba, esa instalación no recibe la alarma.
  rotarCodigosPanicoService(idinstalacion: string) {
    return <Observable<any>>this.http.post(this.rutaApi + 'panico/configuracion/' + idinstalacion + '/rotarcodigos', {}, this.httpOptionsConToken()).pipe();
  }

  async getInstalacionesByClienteService(idcliente: string): Promise<any> {
    try {
      let response = await this.http.get(this.rutaApi + 'instalacionesByCliente/' + idcliente).toPromise();
      return response;
    } catch (error) {
      await console.error('Error es:', error);
    }
  }

}